/* Full Feast — Recipe blog index filtering (client-side)
 *
 * Reads data-* attributes on each .ff-recipe-card and hides/shows
 * cards based on the active chip filters. Multi-dimensional AND.
 * Dimensions: pillar, heat, time, course, effort, diet, sauce.
 */
(function () {
  const section = document.querySelector('.ff-recipe-index');
  if (!section) return;

  const sidebar = section.querySelector('[data-filter-bar]');
  const filterToggle = section.querySelector('[data-filter-toggle]');
  const filterCount = section.querySelector('[data-filter-count]');
  const resultsCount = section.querySelector('[data-results-count]');
  const clearButtons = section.querySelectorAll('[data-filter-clear]');
  const chips = section.querySelectorAll('[data-filter]');
  const cards = section.querySelectorAll('[data-recipe-card]');
  const emptyState = section.querySelector('[data-empty-state]');
  const totalCards = cards.length;

  const active = {
    pillar: '',
    heat: '',
    time: '',
    course: '',
    effort: '',
    diet: '',
    sauce: ''
  };

  function cardMatchesMulti(cardValue, filterValue) {
    if (!filterValue) return true;
    if (!cardValue) return false;
    const values = cardValue.split(/\s+/).filter(Boolean);
    return values.includes(filterValue);
  }

  function cardMatchesSingle(cardValue, filterValue) {
    if (!filterValue) return true;
    return cardValue === filterValue;
  }

  function cardMatches(card) {
    if (!cardMatchesSingle(card.dataset.pillar, active.pillar)) return false;
    if (!cardMatchesSingle(card.dataset.heatBand, active.heat)) return false;
    if (!cardMatchesSingle(card.dataset.timeBand, active.time)) return false;
    if (!cardMatchesSingle(card.dataset.course, active.course)) return false;
    if (!cardMatchesSingle(card.dataset.effort, active.effort)) return false;
    if (!cardMatchesMulti(card.dataset.diets, active.diet)) return false;
    if (!cardMatchesMulti(card.dataset.sauces, active.sauce)) return false;
    return true;
  }

  function applyFilters() {
    let visible = 0;
    cards.forEach(function (card) {
      if (cardMatches(card)) {
        card.classList.remove('is-hidden');
        visible++;
      } else {
        card.classList.add('is-hidden');
      }
    });
    if (emptyState) emptyState.classList.toggle('is-hidden', visible > 0);

    const activeCount = Object.values(active).filter(Boolean).length;
    if (filterCount) filterCount.textContent = activeCount > 0 ? String(activeCount) : '';

    if (resultsCount) {
      const word = visible === 1 ? (resultsCount.dataset.itemNoun || 'recipe') : (resultsCount.dataset.itemPlural || 'recipes');
      if (activeCount === 0) {
        var itemNoun = resultsCount.dataset.itemNoun || 'recipe';
        resultsCount.textContent = totalCards + ' ' + (totalCards === 1 ? itemNoun : (resultsCount.dataset.itemPlural || itemNoun + 's'));
      } else {
        resultsCount.textContent = visible + ' ' + (resultsCount.dataset.of || 'of') + ' ' + totalCards + ' ' + word;
      }
    }
  }

  function setChip(filterName, value) {
    active[filterName] = value;
    chips.forEach(function (chip) {
      if (chip.dataset.filter === filterName) {
        chip.classList.toggle('is-active', chip.dataset.value === value);
      }
    });
    applyFilters();
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      setChip(chip.dataset.filter, chip.dataset.value);
    });
  });

  clearButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      Object.keys(active).forEach(function (k) {
        setChip(k, '');
      });
    });
  });

  if (filterToggle && sidebar) {
    filterToggle.addEventListener('click', function () {
      const isOpen = sidebar.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  // Initialise results count
  applyFilters();
})();
